var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HDSButton } from "@here/hds-react-components/Button";
import { HDSIcon } from "@here/hds-react-components/Icon";
import { useToast } from "@here/hds-react-components/Notification";
import { setDiscardAllAnnotations, } from "../../../../store/reducers/jsMapSlice";
import "./style.scss";
import translations from "../../../../translations/resources/en-GB.json";
import { openInIMC } from "../../../../api/indoorMapOperations";
import Loader from "../../../../components/loader/index";
import { createMap, onCloseEntryModal, removeMapObjects } from "../../helper";
import { ANNOTATION_DISCARD_MODAL, ANNOTATION_ENTRY_MODAL, } from "../../../../pages/JsMapCreator/constants";
import { MapNavBar } from "../MapNavBar";
import { ConfirmDailog } from "../../../../generic-components/ConfirmDailog";
import { ConfirmFooter } from "../confirm-footer-body";
import { ConfirmEntryBody } from "../confirm-entry-body";
import { PORTAL_TABS } from "../../../../store/common/constants";
import H from "@here/maps-api-for-javascript";
export var JSIndoorMap = function (props) {
    var indoorMapId = props.indoorMapId, venue = props.venue;
    var dispatch = useDispatch();
    var addToast = useToast().addToast;
    // const token = useSelector((state: { user: userState }) => state.user.token);
    var indoorCatalogHrn = useSelector(function (state) { return state.app.indoorCatalogHrn; });
    var defaultCollectionHrn = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.overview.defaultHrn; });
    var momData = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jsMap) === null || _a === void 0 ? void 0 : _a.momData; });
    var annotationPresent = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jsMap) === null || _a === void 0 ? void 0 : _a.annotationPresent; });
    // It refers to map object from platform
    var mapRef = useRef();
    var selectedTab = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.selectedTab; });
    var bubbles = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jsMap) === null || _a === void 0 ? void 0 : _a.bubbles; });
    var discardAllAnnotations = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jsMap) === null || _a === void 0 ? void 0 : _a.discardAllAnnotations; });
    // this is to denote weather api has been called or not, if yes and no features then show no map view
    var _a = useState(false), isMomDataLoaded = _a[0], setIsMomLoaded = _a[1];
    var _b = useState(false), showModal = _b[0], setShowModal = _b[1];
    var _c = useState(false), showEntryModal = _c[0], setShowEntryModal = _c[1];
    var _d = useState(false), isFloorPlansOnly = _d[0], setFloorPlansOnly = _d[1];
    var iconStyle = {
        "--hds-icon-color": "var(--hds-foreground-inactive)",
    };
    var handleFloorPlansOnly = function (canSubmitOnlyFloorPlans) {
        setFloorPlansOnly(canSubmitOnlyFloorPlans);
        setShowEntryModal(false);
    };
    var notify = function (title, body, duration, variant) {
        return addToast({
            // notificationTitle: title,
            body: (_jsx("div", { children: _jsx("p", { children: body }) })),
            timeout: duration,
            variant: variant,
        });
    };
    useEffect(function () {
        var options = {
            H: H,
            mapRef: mapRef,
            setIsMomLoaded: setIsMomLoaded,
            indoorCatalogHrn: indoorCatalogHrn,
            indoorMapId: indoorMapId,
            defaultCollectionHrn: defaultCollectionHrn,
            bubbles: bubbles,
            setShowEntryModal: setShowEntryModal,
            setShowModal: setShowModal,
        };
        if (indoorCatalogHrn) {
            dispatch(createMap(options));
        }
    }, []);
    useEffect(function () {
        discardAllAnnotations && dispatch(removeMapObjects);
        dispatch(setDiscardAllAnnotations(false));
    }, [discardAllAnnotations]);
    var getMapStyle = function () {
        var _a;
        var style = {};
        var className = "indoorMap";
        // if map div and api has loaded and its length is 0(error in mom data also captured here) scenario
        if (((_a = momData === null || momData === void 0 ? void 0 : momData.features) === null || _a === void 0 ? void 0 : _a.length) === 0 && isMomDataLoaded && (mapRef === null || mapRef === void 0 ? void 0 : mapRef.current)) {
            style = { display: "none" };
            className = "";
            // initially no mom data or no mom api called and map ref also not loaded then hide this div
        }
        else if (momData === null || (!isMomDataLoaded && (mapRef === null || mapRef === void 0 ? void 0 : mapRef.current))) {
            style = { visibility: "hidden" };
            className = "";
        }
        return { style: style, className: className };
    };
    var mapDiv = function () {
        var _a;
        var _b = getMapStyle(), style = _b.style, className = _b.className;
        return (_jsxs(_Fragment, { children: [showModal && (_jsx(ConfirmDailog, { hideCloseBtn: false, header: "Your update requests hasn\u2019t been added yet", footer: _jsx(ConfirmFooter, { setShowModal: setShowModal }), onClose: function () {
                        onCloseEntryModal(), setShowModal(false);
                    }, renderBody: function () { return _jsx("p", { children: ANNOTATION_DISCARD_MODAL.MESSAGE }); } })), showEntryModal && (_jsx(ConfirmDailog, { header: ANNOTATION_ENTRY_MODAL.HEADER, hideCloseBtn: false, onClose: function () {
                        onCloseEntryModal(), setShowEntryModal(false);
                    }, renderBody: function () { return (_jsx(ConfirmEntryBody, { setShowEntryModal: setShowEntryModal, onFloorPlansOnlyClick: handleFloorPlansOnly })); } })), _jsxs("div", __assign({ className: className, style: style }, { children: [selectedTab !== PORTAL_TABS.INTERNAL_TOOLS && (
                        //TODO: rename the MenuBar component and it should hold the icons which asked as feature.
                        // respective component should be created for each icon functionality.
                        _jsx(MapNavBar, { venue: venue, annotationPresent: annotationPresent, isFloorPlansOnly: isFloorPlansOnly, onSourceOnlyClick: setFloorPlansOnly, showEntryModal: setShowEntryModal })), _jsx("div", __assign({ "data-testid": "mapContainer", id: "mapContainer", className: "mapContainer", style: {
                                height: "600px",
                            } }, { children: selectedTab === "internalTools" &&
                                venue.draftStatus === "Checked out" ? (_jsx("div", __assign({ className: "pencilIcon" }, { children: _jsx(HDSButton, { icon: "edit", variant: "secondary", onClick: function () { return dispatch(openInIMC(venue, notify)); } }) }))) : (_jsx(_Fragment, {})) }))] })), ((_a = momData === null || momData === void 0 ? void 0 : momData.features) === null || _a === void 0 ? void 0 : _a.length) === 0 && isMomDataLoaded && (_jsxs("div", __assign({ className: "noIndoorMap" }, { children: [_jsx("div", { children: _jsx(HDSIcon, { name: "attention", "icon-style": "outline", size: "24px", style: iconStyle }) }), _jsx("div", { children: translations.data["venonboard.realmSetup.errorHeading"] })] })))] }));
    };
    return (_jsxs(_Fragment, { children: [momData === null && !(mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) && _jsx(Loader, {}), mapDiv()] }));
};
